import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { UserService } from '../../../services/user/user.service';
import { Observable, tap, from } from 'rxjs';
import { AccountTypeDTO } from '../../../dto/users/account-types.dto';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../../services/auth/auth.service';
import { Store } from '@ngrx/store';
import { MatDialogModule } from '@angular/material/dialog';
import * as AuthActions from '../../../ngrx/auth/auth.actions';
import { ModalService } from '../../../services/modal/modal.service';
import { environment } from '../../../environment/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-duna-accounttypes',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  templateUrl: './duna-accounttypes.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./duna-accounttypes.component.scss'],
})
export class DunaAccounttypesComponent {
  accountTypes$: Observable<AccountTypeDTO[]>;
  private readonly apiUrl = `${environment.apiUrl}`;

  constructor(
    private userService: UserService,
    private http: HttpClient,
    private authService: AuthService,
    private store: Store,
    private modalService: ModalService,
    private router: Router
  ) {
    this.accountTypes$ = this.userService.getAccountTypes().pipe(
      tap((accountTypes) => {
      })
    );
  }

  public switchToAccount(accountType: AccountTypeDTO): void {
    this.http
      .post(`${this.apiUrl}/users/impersonate`, {
        organizations_id: accountType.organizations_id,
        accounttype: accountType.accounttype,
      })
      .subscribe({
        next: () => {
          // Close all modals using the modal service
          this.modalService.closeAllModals();

          // Convert Promise to Observable and refresh the token
          from(this.authService.refreshTokenAndRetry()).subscribe({
            next: (token: string) => {
              // Extract user from token and dispatch loginSuccess
              const user = this.authService.extractUserFromToken(token);

              // Navigate to root path first, then dispatch loginSuccess
              // The loginSuccess effect will handle navigation to the appropriate landing page
              this.router.navigate(['/']).then(() => {
                // Small delay to ensure router state is updated
                setTimeout(() => {
                  this.store.dispatch(
                    AuthActions.loginSuccess({
                      token,
                      user,
                      isAuthenticated: true,
                      shouldNavigate: true,
                    })
                  );
                }, 0);
              });
            },
            error: (error: Error) => {
              console.error(
                '[DunaAccounttypes] Error refreshing token:',
                error
              );
            },
          });
        },
        error: (error) => {
          console.error('[DunaAccounttypes] Error switching account:', error);
        },
      });
  }
}
